var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{staticClass:"how-to-set",attrs:{"display":_vm.modalStatus.howToSetTasker},on:{"modalStatus":_vm.closeModal}},[_c('h1',[_vm._v("受託人資料？")]),_vm._v(" "),_c('div',{staticClass:"how-to-set-wrap"},[_c('ul',[_c('li',[_vm._v("1. 在飛豬出租中：系統會自動帶入房客姓名及電話")]),_vm._v(" "),_c('li',[_vm._v("2. 空房：輸入受託人在飛豬會員的電話")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6316a46e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widge/modal/howToSetTasker.vue
// module id = null
// module chunks = 